import { tracked } from '@glimmer/tracking';

export class GraphResultMeta {
  @tracked modelRunMembers;
  constructor({ modelRunMembers } = {}) {
    this.modelRunMembers = modelRunMembers;
  }
}
